import { listBrandsAlphabet } from '../../bind/brand';
import { RuntimeClientAtom } from '@vs-shop/engine/runtime/RuntimeClient';
import * as Atom from 'effect/unstable/reactivity/Atom';

export const getBrandsAlphabetAtom = RuntimeClientAtom.atom(listBrandsAlphabet).pipe(
  Atom.keepAlive
);
